"use strict";
module.exports = {
    entityModel: 'shopUser',
    events: {
        SHOP_USER_UPDATED: 'SHOP_USER_UPDATED',
        SHOP_USER_CREATED: 'SHOP_USER_CREATED',
        SHOP_USER_PREFERRED_CUSTOMER_SUB_UNIT_UPDATED: 'SHOP_USER_PREFERRED_CUSTOMER_SUB_UNIT_UPDATED',
        SHOP_USER_APPROVED: 'SHOP_USER_APPROVED',
        SHOP_USER_DISAPPROVED: 'SHOP_USER_DISAPPROVED',
        SHOP_USER_ACTIVATED: 'SHOP_USER_ACTIVATED',
        SHOP_USER_DEACTIVATED: 'SHOP_USER_DEACTIVATED',
        SHOP_USER_EMAIL_VERIFIED: 'SHOP_USER_EMAIL_VERIFIED',
        SHOP_USER_SENT_FORGOT_PASSWORD_LINK: 'SHOP_USER_SENT_FORGOT_PASSWORD_LINK',
        SHOP_USER_PASSWORD_CHANGED: 'SHOP_USER_PASSWORD_CHANGED',
        SHOP_USER_SUPPLIER_CUSTOMER_CHANGED: 'SHOP_USER_SUPPLIER_CUSTOMER_CHANGED',
    },
    actions: {
        get: 'v1.shopUser.get',
        list: 'v1.shopUser.list',
        registerWithNewCustomerSubUnit: 'v1.shopUser.registerWithNewCustomerSubUnit',
        registerWithExistingCustomerSubUnit: 'v1.shopUser.registerWithExistingCustomerSubUnit',
        registerWithNewSupplierCustomer: 'v1.shopUser.registerWithNewSupplierCustomer',
        registerWithExistingSupplierCustomer: 'v1.shopUser.registerWithExistingSupplierCustomer',
        registerThroughInvite: 'v1.shopUser.registerThroughInvite',
        login: 'v1.shopUser.login',
        changeActiveMembership: 'v1.shopUser.changeActiveMembership',
        me: 'v1.shopUser.me',
        restaurantReport: 'v1.shopUser.restaurantReport',
        changePassword: 'v1.shopUser.changePassword',
        sendForgotPasswordLink: 'v1.shopUser.sendForgotPasswordLink',
        restorePassword: 'v1.shopUser.restorePassword',
        validatePasswordToken: 'v1.shopUser.validatePasswordToken',
        updateMe: 'v1.shopUser.updateMe',
        writeShopUser: 'v1.shopUser.writeShopUser',
        approve: 'v1.shopUser.approve',
        disapprove: 'v1.shopUser.disapprove',
        verifyEmail: 'v1.shopUser.verifyEmail',
        activate: 'v1.shopUser.activate',
        deactivate: 'v1.shopUser.deactivate',
        changeCustomer: 'v1.shopUser.changeCustomer',
        getCustomerForSessionUser: 'v1.shopUser.getCustomerForSessionUser',
        upsert: 'v1.shopUser.upsert',
        upsertWhenEmpty: 'v1.shopUser.upsertWhenEmpty',
        updateWhenEmpty: 'v1.shopUser.updateWhenEmpty',
        update: 'v1.shopUser.update',
    },
};
